import { tracked } from '@glimmer/tracking';

import FilterSortReportAtSelectPopup from 'webapp/models-custom/filter-sort/report-at-select-popup';

export default class FilterSortReportAtSelectPopupInGrid extends FilterSortReportAtSelectPopup {
	@tracked override viewId = 'grid';
	override itemDomSelector = 'li.filter-sort-item';
}
